import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;

  &.large {
    zoom: 1.3;
  }
`;
